import { LitElement, html, css, nothing, PropertyValues } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { FiSubView, UiStateModel, UiStateModelParam } from '../../../src/models/ui-state-model';
import { debounce } from '../../../src/utils/helpers';
import { SvgIcons } from '../../voyage-svg-icons/src/voyage-svg-icons';
import { ItemType, SearchListCategory, TypeAHeadSelectEvent } from '../src/types';
import "@maersk-global/mds-components-core/mc-radio";
import {  ShoreContextEvent } from '../../../src/models/types/voyage-shore-context-model.types';
import { VesselsModel } from '../../../src/models/vessels-model';
import { VoyFleetAlarmModel } from '../../../src/models/voy-fleet-alarm-model';
import { GlobalSearchsVesselsMetaData, GlobalSearchsPortsMetaData, GlobalSearchsMetaData } from '../../../src/models/types/vessels-model.types';
import { VoyageShoreContextModel } from '../../../src/models/voyage-shore-context-model'
import "@maersk-global/mds-components-core/mc-pagination";
import { FI_EVENT_CATEGORIES, FI_VESSEL_LIST_ACTIONS, TraceService } from '../../../src/services/trace-service';
import { TerminalInfo } from '../../../src/models/types/terminals-model.types';
import "@maersk-global/mds-components-core";
import { MapView } from '../../voyage-map/src/voyage-map';
import { VoyageSchedulesModel } from '../../../src/models/voyage-schedules-model';
import { VesselVoyageVersion } from '../../voy-global-filters/src/types';


const MAX_PAGINATION_SIZE = 20;

@customElement('voy-global-search')
export class VoyGlobalSearch extends LitElement {
    public static areVesselsLoaded: boolean = false
    @property({ attribute: false }) private _input: HTMLInputElement | null = null;
    @property({ type: Number, attribute: false }) private _listLength: number = 0;
    @property({ type: Number, attribute: false }) private _portsListLength: number = 0;
    @property({ type: Number, attribute: false }) private _vesselListLength: number = 0;
    @property({ type: Number, attribute: false }) private _paginationLength: number = 0;
    @property({ type: Number, attribute: false }) private _selectedPaginationNumber: number = 1;
    @property({ type: Boolean, attribute: false }) private _showDropdown: boolean = false;
    @property({ type: String, attribute: false }) private _searchString: string = "";
    @property({ type: String, attribute: false }) private _selectedOption: string = SearchListCategory.ALL;
    @property({ type: Object }) private _terminals: TerminalInfo[] = [];
    @property({ type: Array, attribute: false }) private _shownListItems: Array<GlobalSearchsVesselsMetaData> = [];
    @property({ type: Array, attribute: false }) private _portsItems: Array<GlobalSearchsPortsMetaData> = [];
    @property({ type: Array, attribute: false }) private _allItems: Array<GlobalSearchsMetaData> = [];
    @property({ type: Boolean }) private _clickHandlerForLoader: boolean = false;
    @property({ type: Boolean }) private _searchInProgress: boolean = false;
    @property({ type:Number })   private _currentItemIndex = 0;
    @property({ type:Boolean })   private _timeLineVisible : boolean= false;
    @property({ type:Boolean })   private _showSearch : boolean= true;
    @property({ type:Boolean })   private _showAnchorIcon : boolean= false;


    private _globalSearchWorker: Worker | null = null;

    constructor() {
        super();
        this.onInput = this.onInput.bind(this);
        this._renderPort = this._renderPort.bind(this);
        this._renderPortRegions = this._renderPortRegions.bind(this);
        this._getListLength = this._getListLength.bind(this);
        this._shuffleArray = this._shuffleArray.bind(this);
        this._renderList = this._renderList.bind(this);
        this._renderEmptyMessage = this._renderEmptyMessage.bind(this);
        this._toggleTimeLine = this._toggleTimeLine.bind(this);
        this._toggleShowOrHide =  this._toggleShowOrHide.bind(this);
        this._setPanelVisibility = this._setPanelVisibility.bind(this);
        if(localStorage.getItem("timeLineView")!==undefined) {
            this._timeLineVisible = localStorage.getItem("timeLineView")=="true";
        }
    }

    static get styles() {
        return [
            css`
            :host {
                position: relative;
                display: flex;
                flex-direction: row;
                column-gap: 16px;
                align-items: center;
                background: white;
                font-family: MaerskText;
            }
            .backdrop {
                display: none;
                position: fixed;
                width: 100vw;
                left: 0px;
                top: 0px;
                background-color: rgba(0, 0, 0, 0.3);
                z-index: -2;
            }
            .backdrop[show] {
                display: block;
            }
            label {
                height: 24px;
                line-height: 24px;
            }
            .input-container {
                position: relative;
                display: flex;
                flex-direction: row;
                align-items: center;
                column-gap: 8px;
                background-color: white;
                flex: 1 1 auto;
                background: white;
                box-shadow: 0 6px 8px -1px rgba(20, 20, 20, 0.25);
            }
            .input-container:focus-within {
                outline: none;
                box-shadow: 0px 4px 12px rgba(20, 20, 20, 0.06), 0px 2px 4px rgba(20, 20, 20, 0.1);
            }
            input {
                flex: 1 1 auto;
                border: none;
                font-family: MaerskText;
                font-size: 16px;
                line-height: 24px;
                letter-spacing: 0em;
                background: white;
            }
            input:focus,
            input:focus-visible {
                outline: none;
            }

            .search-input-container {
                display: block;
                position: relative;
                font-family: MaerskText;
                font-size: 14px;
                line-height: 16px;
                font-weight: 400;
                width: 100%;
            }
            
            input {
                width: 100%;
                height: 57px;
                padding: 16px 10px 16px 50px;
                box-sizing: border-box;
                border-radius: 5px;
                font-size: 14px;
            }
            input:focus,
            input:active {
                outline: none;
                box-shadow: none;
            }
            input::placeholder {
                color: var(--neutrals-grey-05, grey);
            }
            .options {
                margin-top: 0px;
                display: none;
                max-height: calc(100vh - 212px);
                overflow-y: auto;
                margin-bottom: auto;
            }
            .options-full {
                max-height: calc(100vh - 157px);
            }
            .options[show] {
                display: block;
                padding-inline-start: 0px;
            }
            .radio-buttons {
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                padding: 10px 16px;
                gap: 16px;
                border-bottom: 1px solid var(--neutrals-grey-05, grey);
                padding-top:16px;
            }
            .option {
                display: flex;
                justify-content: center;
                flex-direction: column;
                list-style: none;
                cursor: pointer;
                pointer-events: all;
                font-size: 14px;
                color: var(--neutrals-grey-02, grey);
                pointer-events: all;
                border-bottom: 1px solid var(--neutrals-grey-06);
                padding-right: 16px;
                padding-left: 18px !important;
                height: 63px;
            }
            .option-item{
                display:flex;
                justify-content:space-between;
            }
            .title {
                justify-content:space-between;
            }
            .icon {
                align-self: center;
            }
            .option h4 {
                margin: 0px;
                font-size: 14px;
                flex: 1 1 auto;
                color: var(--voyage-black);
                height: 20px;
                line-height: 16px;
                font-family: Maersk Text;

            }
            .option:hover {
                background-color: var(--neutrals-grey-08, grey);
            }
            .option:focus {
                background-color: var(--neutrals-grey-08, grey);
                outline: none;
            }

            .option.no-results h2,
            .option.no-results p {
                font-size: 14px;
                line-height: 20px;
                margin: 0;
            }
            .search-icon {
                position: absolute;
                left: 13px;
                top: 14px;
            }

            .search-icon svg{
                margin-left: -6px;
                border-radius: 50%;
                width: 20px;
                padding: 5px;
                background-color: #0ba1df;
            }

            .search-left-icon {
                position: absolute;
                right: 13px;
                top: 19px;
            }

            .option-item, .ocl-port h4{
                cursor: pointer;
            }
            .ocl-port{
                border-bottom: 1px solid var(--neutrals-grey-06);
            }
            .sub-title {
                font-size: 12px;
                color: var(--neutrals-grey-04);
                margin: 0px;
            }
            .empty-message {
                border-top: 2px solid var(--neutrals-grey-06);
                padding:20px;
                font-size: 15px;
                color: var(--neutrals-grey-03);
                font-size: 15px;
                font-weight: var(--paragraph-weight, normal);
                line-height: 24px;
                text-align: center;
            }
            .dropdown {
                position: absolute;
                margin: 0;
                padding: 0;
                z-index: -1;
                top: 56px;
                display: none;
                width: 324px;
                box-shadow: 1px 3px 10px 0px rgba(0,0,0,.2);
                background-color: var(--neutrals-grey-10, grey);
            }
            .dropdown[show] {
                display: block;
            }
            .pagination-container {
                display: flex;
                justify-content: space-evenly;
                align-items: center;
                width: 100%;
                height: 80px;
                border-top: 1px solid var(--neutrals-grey-06);
            }
            .pagination-container > span {
                cursor: pointer;
                width: 30px;
                height: 32px;
                border-radius: 3px;
            }
            .pagination-container > span[selected] {
                background: #00243D;
                color: #FFFFFF;
            }
            .spinner{
                position: fixed;
                left: 50%;
                top: 50px;
                background-color: rgba(255,255,255,0.8);
                margin: 0;
                padding: 16px;
            }
            .premium-icon{
                margin-left: -10px;
            }

            mc-radio::part(checkmark) {
                background-color: white;
                border-color: var( --neutrals-grey-06,gray)
            }

            mc-radio[checked]::part(checkmark) {
                background-color: var(--primary-blue-300,blue);
                border-color: var(--primary-blue-300,blue);
            }

            mc-radio .mc-button.primary-filled button {
                background-color: var(--primary-blue-300,blue);
            }
            .search-icon[showSearch] {
                height: 20px;
                box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.5);
                border-radius: 50%;
                width: 20px;
                background-color: #0ba1df;
            }
            .search-icon[showSearch] svg{
                height: 22px;
                width: 22px;
            }
            `   
        ];
    }

    render() {
        // vesselsDataLoaded : Checking for vessel data , if it is loaded or not (useful for rendering loader)
        let vesselsDataLoaded = VesselsModel?.maerskVessels && VesselsModel?.maerskVessels.size > 0 || false;
        VoyGlobalSearch.areVesselsLoaded = VesselsModel!.maerskVessels && VesselsModel!.maerskVessels.size > 0
        
        return html`
            <div class="backdrop" ?show=${this._showDropdown} @click=${this._closeDropdown}></div>
            <div class="input-container"  @mouseenter =${()=>this._showLeftPanel(true)} 
                        @mouseleave =${()=>{                              
                            if(this._showAnchorIcon){
                                this._showLeftPanel(false)
                            }
                        }}>
                <div class="search-input-container" @click=${() => {
                    if (!this._clickHandlerForLoader){
                        this._clickHandlerForLoader = true;
                    }
                }}>
                    <div class="search-icon" 
                        ?showSearch=${!this._showSearch}
                        >
                        ${SvgIcons.customSearch}
                    </div>
                        ${this._showSearch ? html`<input 
                            type="text"
                            class="search-input"
                            placeholder="Search vessel, IMO, class, port, OCL"
                            @click=${() => this.setDropdownVisibility(true)}
                            ?disabled=${!vesselsDataLoaded}
                               >


                            <div class="search-left-icon" >
                                ${this._showAnchorIcon ?html`<span  @mouseenter =${()=>this._showLeftPanel(true)} @click = ${()=>this._toggleShowOrHide(true)}>${SvgIcons.pinIcon}</span> `: 
                                html`<span @click = ${()=>this._toggleShowOrHide(false)}>${SvgIcons.arrowLeft}</span> `}</div>` : nothing}
                        ${!vesselsDataLoaded
                        ? (html`<div class="spinner"><mc-loading-indicator fit="large" label="Loading vessels"></mc-loading-indicator></div>`)
                        : nothing}
                        ${this._renderDropdown(vesselsDataLoaded)}
                </div>
                
            </div>
        `
    };

    private _renderDropdown(vesselsDataLoaded: boolean) {
        if (this._allItems.length && this._searchString !== "") {
            return html`
            <div class="dropdown" ?show=${this._showDropdown && vesselsDataLoaded && this._input!.value && this._allItems.length>0} @mouseenter = ${()=> {
                UiStateModel!.setLeftPanelVisibility(true);
                this._showDropdown = true;
                }} >
                ${this._renderRadioButtons()}
                ${this._renderList(this._selectedOption)} 
                
            </div>
           `
        }
        
        if (!this._searchInProgress && !this._allItems.length && this._searchString !== "" && vesselsDataLoaded) {
            return this._renderEmptyMessage();
        }
    }
    
    private _focusListItem(){
        const optionItems = this.shadowRoot!.querySelectorAll('.option');
        (optionItems?.[this._currentItemIndex] as HTMLElement)?.focus();
    }

    private _renderRadioButtons() {
        // Here rendering the list conditioned to radio button selected;
        return html`
        <div class="radio-buttons">
            ${['All', 'Vessels', 'Ports'].map(label => {
                let category: SearchListCategory, items =[] ;
                switch (label) {
                    case 'All':
                        category = SearchListCategory.ALL;
                        items = this._allItems;
                        break;
                    case 'Vessels':
                        category = SearchListCategory.VESSEL;
                        items = this._shownListItems;
                        break;
                    case 'Ports':
                        category = SearchListCategory.PORT;
                        items = this._portsItems;
                        break;
                }
                const disabled = !(items.length > 0);
                const checked = label === 'All';
                return html`
                <mc-radio
                    name="radio"
                    label=${label}
                    ?disabled=${disabled}
                    @change=${() => this._onRadioChange(category)}
                    ?checked=${checked}
                >
                </mc-radio>
                `;
            })}
        </div>`
    }

    private _renderList(option: string){
        let listItems = this._allItems;
        let className = this._timeLineVisible ? "options" : "options options-full"

        switch (option) {
            case "all":
                listItems = this._allItems;
                break;
            case "port":
                listItems = this._portsItems;
                break;

            case "vessel":
                listItems = this._shownListItems;
        }
        return html`
        <ul class=${className} ?show=${listItems?.length > 0}>
            ${listItems.slice((this._selectedPaginationNumber - 1) * MAX_PAGINATION_SIZE, (this._selectedPaginationNumber) * MAX_PAGINATION_SIZE).map((option, i) => {
                if (option.vesselName) return this._renderVessel(option);
                if (option.city) return this._renderPort(option);
                return this._renderPortRegions(option);
            })}
             ${this._getListLength() > MAX_PAGINATION_SIZE ? (html `<div class="pagination-container">
                    <mc-pagination
                        totalpages=${this._paginationLength}
                        currentpage=${this._selectedPaginationNumber}
                        hiddenlabels
                        visiblepages="6"
                        fit="small"
                        @pagechange=${this._onPaginationChanged}
                    >
                    </mc-pagination>
                </div> `): nothing }
        </ul> 
    `
    }

    private _renderVessel(vessel: GlobalSearchsVesselsMetaData) {
        const title = vessel.vesselName || "--";
        const subtitle = vessel.vesselType;
        const isPremium = VesselsModel?.maerskVessels.get(vessel.imo!)?.vesselVersion === VesselVoyageVersion.Premium;
        return this._renderListItem(ItemType.VESSEL, (e: Event) => this._onVesselSelect(e, vessel), title, subtitle, isPremium);
    }

    private _renderPortRegions(region: GlobalSearchsPortsMetaData) {
        const title = `${region.name} Ports` || "--";
        return this._renderListItem(ItemType.PORT_REGION, () => this._onPortsResgionSelect(region.key), title, "OCL Region");
    }

    private _renderPort(port: GlobalSearchsPortsMetaData) {
        const { city, cityId, terminals } = port;
        let length = terminals?.length || 0;
        let locationID
        let location

        if (terminals && terminals[0]) {
            locationID = terminals[0].locationId;
            location = terminals[0].location
        }
        
        const title = `${city} ${cityId}`;
        const subtitle = length > 1 ? `${terminals?.length} Terminals` : `${location} ${locationID}`;
        
        return this._renderListItem(ItemType.PORT, () => this._onPortSelect(cityId), title, subtitle);
    }

    private _renderListItem(type: ItemType, selectFn: Function, title: string, subtitle?: string, isPremium?: boolean) {
        const icon = type === ItemType.VESSEL ? SvgIcons.vesselListIcon : SvgIcons.portListIcon;
        setTimeout(() => this._focusListItem(),250)
        return html`
            <div class="option" tabindex="0">
                <div class="option-item" @click=${(e: Event) => selectFn(e)}>
                    <div class="title">                  
                        <h4> <span class="premium-icon" ?hidden=${!isPremium}>${SvgIcons.customPremiumVessel}</span>${title}</h4>
                        ${subtitle ? html`<p class="sub-title">${subtitle}</p>` : nothing}
                    </div>
                    <div class="icon">
                        <span >${icon}</span>
                    </div>
                </div>
            </div>
        `
    }

    private _onPortsResgionSelect(region?: string) {
        this.setDropdownVisibility(false)
        UiStateModel!.setValue(UiStateModelParam.PORT);
        UiStateModel!.setValue(UiStateModelParam.FISubView, FiSubView.PortsByRegionView);
        UiStateModel!.setValue(UiStateModelParam.PortRegion, region);
        this._updateMapView();
        this._input!.value = "";
        this._searchString = "";
        this.reset();
    }

    private _onPortSelect(portCityId?: string) {
        this.setDropdownVisibility(false)
        UiStateModel!.setValue(UiStateModelParam.PortRegion);
        UiStateModel!.setValue(UiStateModelParam.FISubView, FiSubView.PortView);
        UiStateModel!.setValue(UiStateModelParam.PORT, portCityId);
        this._updateMapView();
        this._selectedOption = SearchListCategory.ALL
        this._input!.value = "";
        this._searchString = "";
        this.reset();
    }

    private _onVesselSelect(e: Event, listItem: GlobalSearchsVesselsMetaData): void {
        const option = e.currentTarget as HTMLLIElement;
        
        this._input!.value = option.getAttribute("data-label") ?? ""

        const detail: TypeAHeadSelectEvent = {
            value: option.getAttribute("data-value")!,
            label: option.getAttribute("data-label")!,
            index: parseInt(option.getAttribute("data-index")!, 10)
        }

        UiStateModel!.setValue(UiStateModelParam.IMO, listItem?.imo?.toString());
        UiStateModel!.setValue(UiStateModelParam.PORT);
        UiStateModel!.setValue(UiStateModelParam.PortRegion);
        UiStateModel!.setValue(UiStateModelParam.FISubView, FiSubView.VesselDetails);
        TraceService!.event(
            FI_EVENT_CATEGORIES.VESSEL_LIST,
            FI_VESSEL_LIST_ACTIONS.SELECTED_VESSEL,
            listItem?.imo?.toString()
        );
        this._input!.value = "";
        this._closeDropdown();
        this.dispatchEvent(new CustomEvent("change", { detail }))
        this.requestUpdate()
    }

    private _renderEmptyMessage() {
        return html`
        <div class = "empty-message">
            Oops, looks like there’s no match for your search.
            <p>Please check your spelling or try again...</p>
        </div>
    `
    }

    private _updateMapView(): void {
        let coords: number[][] = [];
        const terminals = VoyageShoreContextModel!.terminals;
        for (const terminal of terminals!) {
            coords.push([terminal.longitude, terminal.latitude])
        }
        this.dispatchEvent(new CustomEvent(MapView.AdaptView, {
            detail: coords,
            bubbles: true,
            composed: true,
        }));
    }
    private _onPaginationChanged(e: InputEvent) {
        const selectedPaginationNumber = e.detail;
        if (typeof selectedPaginationNumber === 'number' && selectedPaginationNumber >= 0) {
            this._selectedPaginationNumber = selectedPaginationNumber;
        }
    }

    private _onRadioChange(name: SearchListCategory) {
        this._selectedOption = name
        this._selectedPaginationNumber = 1;
        this._listLength = this._getListLength()

        this._paginationLength = Math.ceil(this._listLength / MAX_PAGINATION_SIZE);

    }
    private _getListLength() {
        switch (this._selectedOption) {
            case "port":
                return this._portsListLength;
            case "vessel":
                return this._vesselListLength
            case "all":
                return this._vesselListLength + this._portsListLength
            default:
                return this._vesselListLength + this._portsListLength

        }
    }
 
    private _closeDropdown() {
        this._input!.value = "";
        this._showDropdown = false;
        this.reset();
    }

    private _setSearchString(val: string) {
        if (this._input) {
            this._searchString = val;
        }
    }

    private _applySearch(): void {
        if (!this._searchString) {
            this.reset();
            return;
        }

        const ranks = VoyFleetAlarmModel!.vesselRanks;
        const searchString = this._searchString;

        const allVessels = VesselsModel!.globalSearchVesselsMetaData
        //new props for the global search utils 
        const maerskVessels = VesselsModel!.globalSearchMaerskVesselsMetaData
        const nonMaerskVessels = VesselsModel!.globalSearchNonMaerskVesselsMetaData
        const scheduleStates = VoyageSchedulesModel?.currentScheduleStates;
        
        const portsList = Array.from(VoyageShoreContextModel!.ports.values())
        const portRegions = Array.from(VoyageShoreContextModel!.regions.values())
        const workerPayload = {
            maerskVessels,
            nonMaerskVessels,
            searchString,
            portsList,
            portRegions,
            scheduleStates
        };


        // The Worker is not being terminated. It's a feature that is frequently used,
        // so avoid creating the worker on every search input by letting the worker persist.
        if (!this._globalSearchWorker) {
            this._globalSearchWorker = new Worker('./web-workers/global-search.worker.js', { type: `module` })
            this._globalSearchWorker.addEventListener("message", (e) => {
                const { vessels, ports } = e.data;
                this._applyWorkerResult(vessels, ports);
            })

            this._globalSearchWorker.postMessage(workerPayload);
        } else {
            this._globalSearchWorker.postMessage(workerPayload);
        }

        this._searchInProgress = true;
    }

    private _shuffleArray() {
        // Shuffling the list or randomizing list with ports and vessels data ;
        let shuffledArray = [];
        for (let i = 0; i < this._listLength; i++) {
            if (this._portsItems[i]) shuffledArray.push(this._portsItems[i]);
            if (this._shownListItems[i]) shuffledArray.push(this._shownListItems[i]);
        }
        return shuffledArray;
    }

    private _applyWorkerResult(vessels: GlobalSearchsVesselsMetaData[], ports: GlobalSearchsPortsMetaData[]) {
        this._shownListItems = vessels;
        this._vesselListLength = this._shownListItems.length;

        this._portsItems = ports
        this._portsListLength = this._portsItems.length;

        this._listLength = this._getListLength()
        this._allItems = this._shuffleArray();

        this._terminals = VoyageShoreContextModel!.terminals ?? [];


        this._paginationLength = Math.ceil(this._listLength / MAX_PAGINATION_SIZE);
        this._selectedPaginationNumber = 1;

        this._searchInProgress = false;
    }

    firstUpdated() {
        const input = this.shadowRoot!.querySelector("input");
        this._input = input;

        if (!this._input) return;
        this._input.addEventListener('input', debounce(this.onInput, 250));
    }
    
    updated(changedProperties: PropertyValues) {
        changedProperties.forEach((oldValue, propName) => {
            const input = this.shadowRoot!.querySelector("input");
            this._input = input;
    
            if (!this._input) return;
            if (propName === "_input"){
                this._input.addEventListener('input', debounce(this.onInput, 250));
            }
            if(this._searchString){
                this._showAnchorIcon = false
                this._showLeftPanel(true)
                UiStateModel!.setShowAnchor(true);          
            }
        });     
    }


    connectedCallback() {
        super.connectedCallback();
        // whenever the vessel has been loaded dispatching the event for informing loader to stop rendering;
        VesselsModel!.addEventListener("vessels-loaded", () => this._isVesselLoaded())
        this.addEventListener("keydown", this._onEnter)
        VoyageShoreContextModel!.addEventListener(ShoreContextEvent.TimeLineViewToggle, this._toggleTimeLine);
        const optionItems = this.shadowRoot!.querySelectorAll('.option');
        (optionItems?.[this._currentItemIndex] as HTMLElement)?.focus();
        UiStateModel!.addEventListener("panel-visibility", <EventListener>((evt: CustomEvent) => {this._setPanelVisibility(evt)}));
        const input = this.shadowRoot!.querySelector("input");
        this._input = input;

        if (!this._input) return;

    }

    disconnectedCallback() {
        super.disconnectedCallback();
        VesselsModel!.removeEventListener("vessels-loaded", () => this._isVesselLoaded())
        this.removeEventListener("keydown", this._onEnter);
        VoyageShoreContextModel!.removeEventListener(ShoreContextEvent.TimeLineViewToggle, this._toggleTimeLine);
        UiStateModel!.removeEventListener("panel-visibility", <EventListener>((evt: CustomEvent) => {this._setPanelVisibility(evt)}));
    }

    reset(): void {
        this._searchString = "";
        this._shownListItems = [];
        this._listLength = 0;

        this._portsItems = [];
        this._portsListLength = 0;

        this._selectedPaginationNumber = 1;
        this._paginationLength = 0

        this._allItems = [];
        this._selectedOption = SearchListCategory.ALL

        this.requestUpdate();
    }

    private setDropdownVisibility(show: boolean) {
        this._showDropdown = show;
    }

    onInput() {
        if(!this._input) return;
        this._setSearchString(this._input!.value);
        this._currentItemIndex = 0
        this._applySearch();
        const optionItems = this.shadowRoot!.querySelectorAll('.option');
        (optionItems?.[this._currentItemIndex] as HTMLElement)?.focus();
    }
    private _isVesselLoaded() {
        this.requestUpdate();
    }
    private _onEnter(event: { key: String ,keyCode : Number }) {
        const optionItems =this.shadowRoot!.querySelectorAll('.option');
        const inputSearch = this.shadowRoot!.querySelector('.search-input')
        if (event.keyCode == 38 || event.keyCode == 40) {
            switch (event.key) {
                case 'ArrowUp':
                  this._currentItemIndex = Math.max(0, this._currentItemIndex - 1);
                  break;
                case 'ArrowDown':
                    this._currentItemIndex = Math.min(optionItems.length - 1, this._currentItemIndex + 1);
                  break;
                default:
                  return; // Exit if the pressed key is not relevant
              }
              for (let i = 0; i < optionItems.length; i++) {
               (optionItems[i] as HTMLElement).blur();
              }
            (optionItems[this._currentItemIndex] as HTMLElement).focus();
        }

        if ( this._selectedOption == 'vessel' && event.key === "Enter" ) {
            this._onVesselSelect(event as any,this._shownListItems[this._currentItemIndex])
            // keeping the event as any because here we are rendering detail via "Enter"   
        }
        if ( this._selectedOption === 'port' && event.key === "Enter" ) {
            this._onPortSelect(this._portsItems[this._currentItemIndex].cityId)
        }
        if (this._selectedOption === 'all' && event.key === "Enter") {
            if(this._allItems[this._currentItemIndex]?.vesselName) {
                this._onVesselSelect(event as any,this._allItems[this._currentItemIndex])
            } 
            if(this._allItems[this._currentItemIndex]?.city) {
                this._onPortSelect(this._allItems[this._currentItemIndex].cityId)
            }
        }
        // While using up and down arrow , we can also search 
        if( (event.keyCode !== 38 && event.keyCode !== 40)) {
            (inputSearch as HTMLElement).focus();
        }
    }

    private _toggleTimeLine(): void {
        this._timeLineVisible = !this._timeLineVisible;
    }

    private _showLeftPanel(state:boolean): void {
        this._showSearch = state;
        UiStateModel!.setLeftPanelVisibility(state);
    }

    private _toggleShowOrHide(flag:boolean): void {
        this._showLeftPanel(flag)
        this._showAnchorIcon = !flag
        UiStateModel!.setShowAnchor(flag);
        if(!flag) this.reset();  
    }

    private _setPanelVisibility(evt: CustomEvent): void {
        this._showSearch = evt.detail.visible
        if(evt.detail.hideAnchor){
            this._showAnchorIcon = false
        }
    }

}
